import type { ItemMiniEntity } from '@/features/item/domain/entities/ItemMiniEntity'
import type { CategoryLevel } from '../enums/CategoryLevel'

export class CategoryMiniEntity {
  id?: number
  iconUrl?: string | null
  name?: string | null
  level?: CategoryLevel
  enabled?: boolean
  specifiedItems?: { item: ItemMiniEntity; categoryId: number }[]
  totalItems?: number
  createdAt?: string
  order?: number
}
